"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Stepper;
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const clsx_1 = __importDefault(require("clsx"));
const index_1 = require("../../index");
const useStyles = (0, styles_1.makeStyles)({
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        '& div:nth-child(n)': {
            marginTop: 0,
            marginBottom: 0,
        },
        '& div:first-child': {
            marginRight: '4px',
        },
        '& div:last-child': {
            marginLeft: '4px',
        },
        '& div:not(:last-child):not(:first-child)': {
            marginLeft: '4px',
            marginRight: '4px',
        },
    },
    spot: {
        height: '8px',
        width: ({ steps }) => String(100 / steps) + '%',
        borderRadius: '15px',
    },
    spotInactiveColor: ({ inactiveColor }) => ({
        backgroundColor: inactiveColor || index_1.StyleVariables.colors.border.default,
    }),
    spotActiveColor: ({ activeColor }) => ({
        backgroundColor: activeColor || index_1.StyleVariables.colors.icon.success,
    }),
});
function Stepper({ steps, activeStep = 0, activeColor, inactiveColor, className, ...res }) {
    const classes = useStyles({ steps, activeColor, inactiveColor });
    const renderedSpots = [];
    for (let index = 1; index <= steps; index++) {
        renderedSpots.push(react_1.default.createElement("div", { key: index, className: (0, clsx_1.default)([
                className,
                classes.spot,
                index <= activeStep
                    ? classes.spotActiveColor
                    : classes.spotInactiveColor,
            ]), "data-testid": index <= activeStep ? 'active' : 'inactive' }));
    }
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)(classes.container, classes['&div:first-child']), ...res }, renderedSpots));
}
